import {Component, Inject, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import dayjs from 'dayjs';
import { catchError, throwError } from 'rxjs';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonFarmFieldModel } from 'src/app/models/season-farm-field-model';
import { CreateSeasonModel } from 'src/app/models/create-season-model';
import { BackCreateSeasonComponent } from '../back-create-season/back-create-season.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';


@Component({
    selector: 'app-create-edit-season',
    templateUrl: './create-edit-season.component.html',
    styleUrls: ['./create-edit-season.component.css'],
    standalone: false
})
export class CreateEditSeasonComponent implements OnInit {
  createSeasonForm: FormGroup;
  filterForm: FormGroup;

  tenantId: string = null;
  seasonId: number = null;
  farmId: number = null;
  fieldId: number = null;

  seasonInfo = null;

  startDate:  string = null;
  endDate:  string = null;

  isEditMode: boolean = false;

  farmList: SeasonFarmFieldModel[] = [];
  selectedFarmAndField: SeasonFarmFieldModel[] = [];
  selectCount: number = 0;
  season: CreateSeasonModel = null;

  fields: any = [];

  selectedseasonFarmsToAddToSeason = [];

  placeholder: string = '-';
  defaultStartDate: string = '';
  defaultEndDate: string = '';

  activeSeasonYES: string = 'Yes';
  activeSeasonNO: string = 'No';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public createEditSeasonDialog: MatDialogRef<CreateEditSeasonComponent>,
    public createEditSeasonBackDialog: MatDialog,
    public nav: NavBarComponent,
    private fb: FormBuilder,
    private seasonManagerService: SeasonManagerService
  ) {

    this.createSeasonForm = new FormGroup({
      seasonDescription: new FormControl('', [Validators.required]),
      seasonNote: new FormControl(''),
      isseasonFarmselected: new FormControl(false),
      filterStartDate: new FormControl('', [Validators.required]),
      filterEndDate: new FormControl('', [Validators.required])
      // isFieldSelected: new FormControl(),
      // isFarmSelected: new FormControl(),
    })

    createEditSeasonDialog.disableClose = true;

  }

  ngOnInit(): void {
    this.isEditMode = this.data?.isEditMode;
    this.seasonInfo = this.data?.seasonInfo;
    this.seasonId = this.data?.seasonId;

    //EDIT MODE
    if (this.isEditMode == true) {
      this.selectedFarmAndField = this.data.farms;
      if (this.seasonInfo !== null) {
        if(this.seasonInfo?.name){
          this.createSeasonForm.controls.seasonDescription.setValue(this.seasonInfo.name);
        }
        if(this.seasonInfo?.note){
          this.createSeasonForm.controls.seasonNote.setValue(this.seasonInfo.note);
        }

        if(this.seasonInfo?.startDate){
          // this.filterStartDate = this.seasonInfo.startDate;
          this.createSeasonForm.controls.filterStartDate.setValue(this.seasonInfo.startDate);
          this.startDate = this.seasonInfo.startDate;

        }

         if(this.seasonInfo?.endDate){
          // this.filterEndDate = this.seasonInfo.endDate;
           this.createSeasonForm.controls.filterEndDate.setValue(this.seasonInfo.endDate);
           this.endDate = this.seasonInfo.endDate;
        }

      }
      this.populateEditSeasonFarmAndFields();
      //END OF EDIT MODE
    }
  }

  toggleAllFarmFieldsSelection(event: any, index: number): void {

    this.farmList[index].isChecked = event.checked;
    this.farmList[index]?.fields?.forEach(fieldItem => {
      if (!fieldItem.isInAnotherActiveSeason) {
        if(fieldItem.isChecked && !event.checked || fieldItem.isChecked && event.checked) {
          this.selectCount--;
        }

        // console.log(fieldItem.isChecked, event.checked)

        fieldItem.isChecked = event.checked;
        fieldItem.isChanged = event.checked;

        if(fieldItem.isChecked) {
          this.selectCount++;
        }
      }
    });
  }


  onFieldSelectedChecked(event: any, fieldIndex: number, farmIndex: number) {
    if(this.farmList[farmIndex].fields[fieldIndex].isChecked && !event.checked) {
      this.selectCount--;
    }

    this.farmList[farmIndex].fields[fieldIndex].isChecked = event.checked;
    if(this.farmList[farmIndex].fields[fieldIndex].isChecked) {
      this.selectCount++;
    }
    this.farmList[farmIndex].fields[fieldIndex].isChanged = !this.farmList[farmIndex].fields[fieldIndex].isChanged;
    this.farmList[farmIndex].isTouched = this.farmList[farmIndex].fields.some(field => field.isChecked && !field.isInAnotherActiveSeason);
  }


  onseasonFarmselectedChecked(event: any, id: number) {
    if (event.checked) {
      // Add to the array if checked
      this.selectedseasonFarmsToAddToSeason.push(id);
    } else {
      // Remove from the array if unchecked
      const index = this.selectedseasonFarmsToAddToSeason.indexOf(id);
      if (index > -1) {
        this.selectedseasonFarmsToAddToSeason.splice(index, 1);
      }
    }
  }

      setFilterStartDate(event: MatDatepickerInputEvent<Date>): void {
          this.startDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '';
           
           if(this.startDate && this.endDate){
              this.populateEditSeasonFarmAndFields();
           }
    }

          setFilterEndDate(event: MatDatepickerInputEvent<Date>): void {
              this.endDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '';
               
               if(this.startDate && this.endDate){
                 this.populateEditSeasonFarmAndFields();
               }
        }


  createNewSeason() {
    this.createSeasonForm.markAllAsTouched();

    if(this.createSeasonForm.valid) {
      this.nav.toggleLoading(true);

      let tenantId = Number(sessionStorage.getItem("selectedTenant"));

      let seasonObj = {
        description: this.createSeasonForm.controls.seasonDescription.value,
        startDate: this.startDate,
        endDate: this.endDate,
        note: this.createSeasonForm.controls.seasonNote.value,
        tenantId: tenantId
      }

      this.seasonManagerService.postNewSeason(seasonObj.description, String(seasonObj.startDate), String(seasonObj.endDate), seasonObj.note, Number(seasonObj.tenantId)).pipe(
          catchError(error => {
            console.error();
            return throwError(() => error);
          })
      ).subscribe((response) => {
        this.season = response;

        if(this.selectCount > 0) {
          this.createNewSeasonDetail();
        } else {
          this.nav.toggleLoading(false);
          this.closeDialog('create', this.season.id);
        }
      });
    }
  }

  updateSeason() {

    this.createSeasonForm.markAllAsTouched();

    if(this.createSeasonForm.valid) {
      this.nav.toggleLoading(true);
      let seasonObj = {
        description: this.createSeasonForm.controls.seasonDescription.value,
        startDate: dayjs(this.createSeasonForm.controls.filterStartDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        endDate: dayjs(this.createSeasonForm.controls.filterEndDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        note: this.createSeasonForm.controls.seasonNote.value
      }

      this.seasonManagerService.updateSeason(seasonObj.description, String(seasonObj.startDate), String(seasonObj.endDate), seasonObj.note, this.seasonId).pipe(
          catchError(error => {
            console.error();
            return throwError(() => error);
          })
      ).subscribe((response) => {
        this.season = response;
        this.nav.toggleLoading(false);
      });

      if(this.selectCount > 0) {
        let currentCount = 0;
        let seasonID = Number(this.seasonId);
        this.farmList.forEach(farm => {
          farm.fields.forEach(field => {
            if (field.isChanged) {
              if (field.isChecked) {
                currentCount++;

                this.seasonManagerService.postNewSeasonDetails(field.id, seasonID).pipe(
                    catchError(error => {
                      console.error();
                      return throwError(() => error);
                    })
                ).subscribe((response) => {
                  if(currentCount === this.selectCount) {
                    this.createEditSeasonDialog.close(true);
                  }
                });

              } else if (!field.isChecked) {
                this.seasonManagerService.deleteSeasonDetail(field.id, seasonID).pipe(
                    catchError(error => {
                      console.error();
                      return throwError(() => error);
                    })
                ).subscribe((response) => {
                  this.createEditSeasonDialog.close(true);
                });
              }
            }
          })
        })
      } else {
        this.createEditSeasonDialog.close(true);
      }
    }
  }

  createNewSeasonDetail() {
    let currentCount = 0;
    this.farmList.forEach(farm => {
      farm.fields.forEach(field => {
        if (field.isChecked) {
          currentCount++;
          this.seasonManagerService.postNewSeasonDetails(field.id, this.season.id).pipe(
              catchError(error => {
                console.error();
                return throwError(() => error);
              })
          ).subscribe((response) => {
            if(currentCount === this.selectCount) {
              this.nav.toggleLoading(false);
              this.closeDialog('create', this.season.id);
            }
          });
        }
      })
    })
  }


  populateCreateNewSeasonFarmAndField() {
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));
    // let startDate = dayjs(this.filterStartDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    // let endDate = dayjs(this.filterEndDate.value).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    this.seasonManagerService.getSeasonFarmsAndFields(Number(tenantId), this.defaultStartDate, this.defaultEndDate).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      response.forEach(item => {
        item.isChecked = false;
      })
      this.farmList = response;

      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });

  }

  populateEditSeasonFarmAndFields() {
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));
    let startDate = dayjs(this.startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    let endDate = dayjs(this.endDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    this.seasonManagerService.getSeasonFarmsAndFields(Number(tenantId), startDate, endDate, this.seasonId).pipe(
      catchError(error => {
        console.error();
        return throwError(() => error);
      })
    ).subscribe((response) => {
      this.farmList = response;
 
      this.farmList.forEach(farm => {

        let currentFarm = this.selectedFarmAndField.find(f => f.id === farm.id);
        let checkAllFields: boolean = false;
        if(currentFarm) {
          checkAllFields = farm.fields.length === currentFarm.fields.length;
        }
        farm.fields.forEach(field => {
          if(checkAllFields) {
            field.isChecked = true;
          } else {
            if(currentFarm?.fields.find(f => f.id === field.id)) {
              field.isChecked = true;
            }
          }
          field.isChanged = false;
          // if(field.isChecked){
          //   this.isFieldSelected = true;
          //   this.createSeasonForm.controls.isFieldSelected.setValue(true);
        })
      })
      setTimeout(() => {
        this.nav.toggleLoading(false);
      }, 1400)

    });
  }


  close(): void {

    const dialogRef = this.createEditSeasonBackDialog.open(BackCreateSeasonComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'back') {
        this.createEditSeasonDialog.close();
      }
    })
  }

  closeDialog(actionType?: string, seasonId?: number): void {
    let closeActions = {
      action: actionType,
      seasonId: seasonId
    }
    this.createEditSeasonDialog.close(closeActions);
  }
}
